import * as React from "react";
import { CommonInfrastructureMachinePolicyOverview, CommonInfrastructureMachinePolicyTopics } from "../../CommonComponents/CommonInfrastructureMachinePolicyViews";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";

export const InfrastructureMachinePoliciesNewRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.machinePolicies.create,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonInfrastructureMachinePolicyOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonInfrastructureMachinePolicyTopics />;
    }
};
